module.exports = __webpack_public_path__ + "static/media/ElectronicServicesVector.8da1bdcc.jpg";